import { createSelector, createSlice } from '@reduxjs/toolkit';
import { isEmpty } from 'lodash';
import { ASOI_PLATFORM_APP_ID } from 'src/constants';
import { getPartnerId } from 'src/services/ApiService';

export const initialState = {
    appRolesMapping: {
        connectedApps: [],
        isLoading: false,
        error: '',
    },
};

export const currentUserSliceId = 'current_user';

const slice = createSlice({
    name: currentUserSliceId,
    initialState,
    reducers: {
        fetchAppRolesMapping(state) {
            state.appRolesMapping = {
                ...state.appRolesMapping,
                connectedApps: [],
                isLoading: true,
                error: '',
            };
        },
        fetchAppRolesMappingSuccess(state, action) {
            const { connectedApps } = action.payload;

            state.appRolesMapping = {
                ...state.appRolesMapping,
                connectedApps,
                isLoading: false,
                error: '',
            };
        },
        fetchAppRolesMappingFailure(state, action) {
            const { message } = action.payload;
            state.appRolesMapping = {
                ...state.appRolesMapping,
                connectedApps: [],
                isLoading: false,
                error: message,
            };
        },
    },
});

export const { fetchAppRolesMapping, fetchAppRolesMappingSuccess, fetchAppRolesMappingFailure } = slice.actions;

const hasAsioPlatformAppFullResourceAccessSelector = createSelector(
    state => state[currentUserSliceId].appRolesMapping?.connectedApps,
    connectedApps => {
        const partnerId = getPartnerId();
        const asioApp = connectedApps?.find(app => app.connectedAppId === ASOI_PLATFORM_APP_ID);
        const roleWithFullResourceAccess = asioApp?.applicationRoles?.find(role => {
            return role.assignedResources?.some(resource => resource.resourceId === partnerId);
        });
        return !isEmpty(roleWithFullResourceAccess);
    }
);
export { hasAsioPlatformAppFullResourceAccessSelector };
export default slice.reducer;
